import React, { useMemo } from 'react';
import { Typography, Card } from 'antd';
import { formatGeometryAreaHa } from '../../utilities/area';

const AreaOverlay = ({ geometry, top = 100, right = 20 }) => {
  const formattedArea = useMemo(() => {
    return formatGeometryAreaHa(geometry);
  }, [geometry]);

  return (
    <div style={{
      position: 'absolute',
      top: `${top}px`,
      right: `${right}px`,
      zIndex: 1000,
      pointerEvents: 'none'
    }}>
      <Card 
        size="small"
        style={{
          background: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          minWidth: '120px'
        }}
      >
        <Typography.Text strong style={{ fontSize: '14px', color: '#1890ff' }}>
          Area: {formattedArea} ha
        </Typography.Text>
      </Card>
    </div>
  );
};

export default AreaOverlay;
